import ReviewContent from './ReviewContent';

export default ReviewContent;
